import { render, staticRenderFns } from "./wallet_owner_types.vue?vue&type=template&id=6fb068c2&scoped=true&"
import script from "./wallet_owner_types.vue?vue&type=script&lang=js&"
export * from "./wallet_owner_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb068c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb068c2')) {
      api.createRecord('6fb068c2', component.options)
    } else {
      api.reload('6fb068c2', component.options)
    }
    module.hot.accept("./wallet_owner_types.vue?vue&type=template&id=6fb068c2&scoped=true&", function () {
      api.rerender('6fb068c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/wallet_owner_types.vue"
export default component.exports